import { render, staticRenderFns } from "./CampaignStorySkeleton.vue?vue&type=template&id=2e0cb872&scoped=true&"
import script from "./CampaignStorySkeleton.vue?vue&type=script&lang=js&"
export * from "./CampaignStorySkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStorySkeleton.vue?vue&type=style&index=0&id=2e0cb872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0cb872",
  null
  
)

export default component.exports